var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('div',{staticClass:"container"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/images/logo.png"),"alt":""},on:{"click":_vm.setHomePage}}),_vm._v(" "),_c('h3',{on:{"click":_vm.setHomePage}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('img',{staticClass:"logo",attrs:{"src":require(("../assets/images/" + _vm.$logo)),"alt":""},on:{"click":_vm.setHomePage}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed0f2c92","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 91
// module chunks = 0